export default __webpack_public_path__ + "static/media/takeaway.a4274ae5.svg";